const prefix = "openViewsModes.";

const OPEN_VIEWS_MODES = {
  desktop: `${prefix}desktop`,
  tablet: `${prefix}tablet`,
  mobileLandscape: `${prefix}mobileLandscape`
};

export default OPEN_VIEWS_MODES;
